<template>
  <div class="head-conter-box">
    <div class="content_box">
      <div class="logo-box">
        <img :src="`${this.$baseUrl}images/logo.png`" alt="">
        <span>浙立保</span>
      </div>
      <el-menu
        :default-active="activeIndex"
        class="el_menu_box"
        :router="true"
        mode="horizontal"
        active-text-color="#167FFF"
        text-color="#1D2129"
        @select="handleSelect"
      >
        <el-menu-item v-for="(item, index) in navList" :key="index + 'nav'" :index="item.routerName" @mouseleave.native="handleMouseLeave(item)" @mouseover.native="handleMouseOver(item)">{{ item.name
        }}</el-menu-item>
        <base-navigation v-if="isShowNav" :nav-item="navItem" @changeNav="changeNav" />
      </el-menu>
    </div>
  </div>
</template>
<script>
import BaseNavigation from '@/components/base/BaseNavigation.vue'

export default {
  name: 'Head',
  components: { BaseNavigation },
  data() {
    return {
      navList: [
        { name: '首页', routerName: '/home' },
        { name: '业务介绍', routerName: '', routerUrl: '/businessIntroduction', navList: [{ name: '履约保函', type: 'performance' }, { name: '投标保函', type: 'bid' }, { name: '诉讼保全担保', type: 'dlProcess' }, { name: '工程数智 AI 大模型', type: 'ai' }] },
        { name: '案例介绍', routerName: '/caseIntroduction', navList: [{ name: '工程招投标行业量化分析', type: '' }] },
        { name: '关于我们', routerName: '/aboutUs' }
      ],
      activeIndex: '/home',
      navItem: {},
      isShowNav: false, // 是否展示导航栏
      isSubassembly: false,
      mouseLeaveTmieout: null
    }
  },
  watch: {
    // 当路由变化时，更新 activeIndex
    '$route'(to) {
      this.activeIndex = to.path
    }
  },
  mounted() {
    // 页面加载时设置 activeIndex 为当前路由的路径
    this.activeIndex = this.$route.path
  },
  methods: {
    handleSelect(index) {
      // 当菜单项被选中时触发的操作，可以根据需要在这里处理
      console.log('Selected menu item:', index)
    },
    // 进入盒子事件
    handleMouseOver(item) {
      if (this.mouseLeaveTmieout) {
        clearTimeout(this.mouseLeaveTmieout)
      }
      this.isShowNav = item.routerUrl === '/businessIntroduction'
      this.navItem = item
    },
    // 子组件状态变更
    changeNav(is, item) {
      this.isSubassembly = is
      this.handleMouseLeave(item)
    },
    // 离开盒子事件
    handleMouseLeave(item) {
      if (item?.routerUrl === '/businessIntroduction') {
        this.mouseLeaveTmieout = setTimeout(() => {
        // 鼠标是否在子组件上
          if (this.isSubassembly) {
            return
          } else {
            this.isShowNav = false
          }
        }, 200)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.head-conter-box {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 888;
  width: 100%;
  min-width: 1280px;
  height: 60px;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.1);
  font-family: PingFang SC, PingFang SC;

  .content_box {
    margin: auto;
    width: 1200px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &:hover {
    background: #FFFFFF;
    box-shadow: 0px 4px 12px 0px rgba(20, 97, 191, 0.04);
  }

  .el_menu_box {
    flex: 1;
    padding: 0 60px;
  }

  .logo-box {
    img {
      margin-right: 12px;
      vertical-align: middle;
      width: 20px;
      height: 20px;
    }

    span {
      color: $primary_black_color;
      font-weight: 400;
      font-size: 16px;
    }
  }

  ::v-deep {
    .el-menu {
      background: rgba(255, 255, 255, 0.1);

    }

    .el-menu-item {
      background-color: transparent !important;

    }

    .el-menu.el-menu--horizontal {
      border: none;
    }

    .el-button {
      border-radius: 0;
    }

    .is-active {
      border-bottom-color: transparent !important;
    }
  }

  .el_menu_box {
    position: relative;

  }
}
</style>
